import React from "react";
import GenericForm from "./GenericForm";
import StringInput from "../formElements/StringInput";
import Addresses from "../../listViews/Addresses";
import Contacts from "../../listViews/Contacts";
import FloatInput from "../formElements/FloatInput";

function CompanyForm(props) {
    function formContent(data, update, updateCustom) {

        function deleteAddress(index) {
            let newData = {...data}
            newData['Adresa'].splice(index, 1)
            updateCustom(newData)
        }

        function updateAddress(event, index) {
            let newData = {...data}
            if (index === newData['Adresa'].length) {
                let newElem = {
                    'Nazov': '',
                    'Mesto': '',
                    'Ulica': '',
                    'PSC': '',
                    'Hlavna_Adresa': false
                }
                newElem[event.target.name] = event.target.value
                newData['Adresa'].push(newElem)
            } else {
                newData['Adresa'][index][event.target.name] = event.target.value
            }
            newData = resetMainAddress(event.target.name, event.target.value, newData, index)
            updateCustom(newData)
        }

        function resetMainAddress(name, value, data, indexToSkip) {
            if (name === 'Hlavna_Adresa') {
                if (value === true) {
                    data['Adresa'].forEach((item, ndx) => {
                        if (ndx !== indexToSkip) {
                            item['Hlavna_Adresa'] = false
                        }
                    })
                }
            }
            return data
        }

        function deleteContact(index) {
            let newData = {...data}
            newData['Kontakt'].splice(index, 1)
            updateCustom(newData)
        }

        function updateContact(event, index) {
            let newData = {...data}
            if (index === newData['Kontakt'].length) {
                let newElem = {
                    'Meno': '',
                    'Telefon': '',
                    'Pevna_linka': '',
                    'Mail': '',
                    'Oddelenie': '',
                }
                newElem[event.target.name] = event.target.value
                newData['Kontakt'].push(newElem)
            } else {
                newData['Kontakt'][index][event.target.name] = event.target.value
            }
            updateCustom(newData)
        }

        return <>
            <StringInput name={'Meno'} label={'Názov'} value={data.Meno} onChange={update}/>
            <StringInput name={'ICO'} label={'IČO'} value={data.ICO} onChange={update}/>
            <StringInput name={'DIC'} label={'DIČ'} value={data.DIC} onChange={update}/>
            <StringInput name={'IC_DPH'} label={'IČ DPH'} value={data.IC_DPH} onChange={update}/>
            <FloatInput name={'Koeficient_marze'} label={'Koeficient'} value={data.Koeficient_marze} onChange={update}/>
            <div className="mb-3">
                {data.Meno !== "" && <>
                    <Addresses
                        data={data}
                        delete={deleteAddress}
                        updateAddress={updateAddress}
                    />
                    <Contacts
                        data={data}
                        delete={deleteContact}
                        updateContact={updateContact}
                    />
                </>
                }
            </div>
        </>
    }

    return (
        <GenericForm label="Zákazník"
                     labelNew="Pridať Zákazníka"
                     baseUrl='/company/companies/'
                     formContent={formContent}/>
    );
}

export default CompanyForm;